import store from '~/store'

const advancedTracking = () => {
  let tConfig = null
  if (store.getters['config/configForKey']('app_config')) {
    [tConfig] = store.getters['config/configForKey']('app_config').config
  }
  if (tConfig && tConfig[0] && tConfig[0].advancedUserTracking) {
    return tConfig[0].advancedUserTracking
  }
  return false
}

export default advancedTracking
